import {Action} from '@ngrx/store';
import {SalesScope} from '../../model/sales-scope';

/**
 * All actions of the sales offer sub-store are described here
 * An action can have an optional payload
 */
export const UPDATE_SCOPE = '[SALES] UPDATE_SCOPE';

/**
 * UPDATE ACTIONS
 */

export class UpdateScopeAction implements Action {
  readonly type = UPDATE_SCOPE;

  constructor(public payload: SalesScope) {
  }
}

export type SalesAction =
    UpdateScopeAction;
